// Tab Configuration
// Defines the default tabs available in the application

import { createTab } from '../../components/layout/TabNavigation';

export const DEFAULT_TABS = [
  createTab('home', 'Home'),
];

// Tab IDs that render a custom full-page component instead of the grid
export const SPECIAL_TABS = [];
